import React from "react";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../helper/Preloader";


import WishListSection from "../components/WishListSection";
import ShippingOne from "../components/ShippingOne";

import BottomFooter from "../components/BottomFooter";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";

function WishlistPage() {
  return (
    <>
      {/* Preloader */}
      <Preloader />
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#FA6400' />

    

   
<HeaderOne/>

      {/* WishListSection */}
      <WishListSection />

      {/* ShippingOne */}
      <ShippingOne />

     
      <FooterOne/>

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
}

export default WishlistPage;
